module.exports = __webpack_public_path__ + "media/Images/resources-hero-smb-d0561dd1fd1b3ca94a3affabd2254475.jpg";